export const journalistDetailMixin = {
    methods: {
        disableFirstPage: function () {
            this.hideFirstPage = true;
        }
    },
    mounted: function () {
        if (this.$refs.prof) {
           this.showMoreContentButton = this.$refs.prof.scrollHeight > this.$refs.prof.offsetHeight 
        }
    },
    data: function () {
        return {
            hideFirstPage: false,
            showProfile: false,
            showMoreContentButton: false
        }
    }
};